import {recipeCategoriesSyncCache} from "./mealplannerApi.ts";
import * as Html from "../util/Html.ts";
import TPL from "./recipeCategoriesEditContent.mustache";

Html.registerWidget('mealplanner/recipeCategoriesEditWidget',{initDom,destroyDom})

var node;

function initDom(obj){
  node = obj;
}
function destroyDom(obj){
  node = undefined;
}
recipeCategoriesSyncCache.subscribe(updateUI)

function updateUI(freshCat){
  if(node){
    var displayabledCat = freshCat.filter(category=>category.categorySystem!=="FAVORITE")
    var selected = [];
    node.querySelectorAll('input').forEach((input :HTMLInputElement)=>{
      if(!input.disabled){
        selected.push(input.value)
      }
    })
    var catWithData = displayabledCat.map(cat=>{
      return {
        assigned:selected.indexOf(cat.metaId)>-1,
        category:cat
      }
    })

    Html.setHtml(node,TPL,{categories:catWithData})
  }

}